module.exports = require("././ui-bootstrap-tpls.js");


//////////////////
// WEBPACK FOOTER
// angular-bootstrap (bower component)
// module id = 1443
// module chunks = 1